import { TouchableOpacity, View, ViewStyle, Platform } from "react-native"
import Icon from "react-native-vector-icons/MaterialIcons"

import { colors } from "@/theme"

interface HomeButtonProps {
  style?: ViewStyle
}

export const HomeButton: React.FC<HomeButtonProps> = ({ style }) => {
  const handlePress = () => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      window.open("https://holdeineplakette.de", "_blank")
    }
  }

  return (
    <TouchableOpacity onPress={handlePress} style={[$container, style]} activeOpacity={0.7}>
      <View style={$iconContainer}>
        <Icon name="home" size={24} color={colors.text} />
      </View>
    </TouchableOpacity>
  )
}

const $container: ViewStyle = {
  backgroundColor: colors.surface,
  borderRadius: 12,
  paddingHorizontal: 12,
  paddingVertical: 8,
  alignItems: "center",
  justifyContent: "center",
  minWidth: 48,
  minHeight: 40,
  ...Platform.select({
    web: {
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      cursor: "pointer",
    },
    default: {
      shadowColor: colors.text,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 3,
    },
  }),
}

const $iconContainer: ViewStyle = {
  alignItems: "center",
  justifyContent: "center",
}
